import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../api/axios";

export default function RevolutPaymentRedirect() {
    const { id } = useParams(); // Get the ID from URL params
    const navigate = useNavigate();

    useEffect(() => {
        const initiateCheckout = async () => {
            try {
                const response = await API.post("/create-express-checkout", {
                    id: id,              // Get from URL
                    email: "",           // Optional, if needed
                    amount: "200",
                    currency: "GBP",
                });

                const checkoutUrl = response.data.data.checkout_url;
                window.location.href = checkoutUrl; // Redirect to Revolut page
            } catch (error) {
                console.error("Checkout redirect failed:", error);
                alert("Unable to initiate payment.");
                navigate("/"); // Fallback route if needed
            }
        };

        if (id) {
            initiateCheckout();
        }
    }, [id, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <p className="text-lg font-semibold text-gray-700">Redirecting to payment page...</p>
        </div>
    );
}
